<template>
  <div class="pdf-zoom">
    <a @click.prevent.stop="zoomIn" class="icon" :disabled="isDisabled">
      <img src="../assets/icon-zoom-in.svg">
    </a>
    <a @click.prevent.stop="zoomOut" class="icon" :disabled="isDisabled">
      <img src="../assets/icon-zoom-out.svg">
    </a>
    <a @click.prevent.stop="fitWidth" class="icon" :disabled="isDisabled">
      <img src="../assets/icon-expand.svg">
    </a>
    <a @click.prevent.stop="fitAuto" class="icon" :disabled="isDisabled">
      <img src="../assets/icon-shrink.svg">
    </a>
    <pdf ref="myPdfComponent" :src="url" style="display:none;" id="pdfprintcontent"></pdf>
    <a @click.prevent.stop="printPdf" class="icon" :disabled="isDisabled"  v-bind:style="{ display: displayprint}">
      <img src="../assets/icon-print.svg">
    </a>
    <a @click.prevent.stop="downloadPdf" class="icon" :disabled="isDisabled" v-bind:style="{ display: displayprint}">
      <img src="../assets/icon-download.svg">
    </a>
  </div>
</template>

<script>
import { SITE_URL } from "@/api/config";
//import $ from 'jquery'
import { arrayutility } from "@/helper";
import pdf from "vue-pdf";

export default {
  name: "PDFZoom",
  components: {
    pdf
  },
  props: {
    scale: {
      type: Number
    },
    increment: {
      type: Number,
      default: 0.25
    },
    url: String,
    postid:String
  },
  created() {
      this.printNotAllowedIpad()
  },
  computed: {
    isDisabled() {
      return !this.scale;
    }
  },

   data() {
    return {
        displayprint :''
    }
   },

  methods: {
    printNotAllowedIpad(){
        if( navigator.platform == 'iPad' ||  navigator.userAgent.match( /(PANARAY iPad)/ )){
            this.displayprint='none'
        }
    },
    zoomIn() {
      this.updateScale(this.scale + this.increment);
    },

    zoomOut() {
      if (this.scale <= this.increment) return;
      this.updateScale(this.scale - this.increment);
    },

    updateScale(scale) {
      this.$emit("change", { scale });
    },

    fitWidth() {
      this.$emit("fit", "width");
    },

    fitAuto() {
      this.$emit("fit", "auto");
    },

    printPdf() {
      this.$refs.myPdfComponent.print();
    },

    downloadPdf() {
      // console.log(this.postid)
      window.location.href = SITE_URL + "/download?file=" + this.url+"&postid="+this.postid;
    }
  }
};
</script>

<style>
.pdf-zoom a {
  float: left;
  cursor: pointer;
  display: block;
  border: 1px #333 solid;
  background: white;
  width: 30px;
  height: 30px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/PDFZoom.vue